export const isLinkExternal = (link: string) => link.startsWith('http')
